/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc ユーザ認証結果ダイアログ
 *
 * @author jimu
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<transition name="modal">
  <div class="fc-chat-user-certificate-result-dialog">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          {{$t('お客様情報が一致しません。')}}
        </div>
        <div class="modal-body">
          <el-button type="primary" class="user-certificate-button" @click="gotoUserCertificate">{{$t('入力画面に戻る')}}</el-button>
        </div>
        <div class="modal-body">
          <el-button type="primary" v-show="showUserNoCertificateBtn" class="user-certificate-button" @click="gotoUserNoCertificate">{{$t('基本情報の入力なしでチャットを始める')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import {
  Button
} from 'element-ui'

export default {
  data() {
    return {
      /**
       * 基本情報の入力なしでチャットを始めるボタンの表示
       * @type {Boolean}
       */
      showUserNoCertificateBtn: false
    }
  },
  components: {
    'el-button': Button
  },
  methods: {
    /**
     *  入力画面に戻る
     */
    gotoUserCertificate() {
      this.$emit('showUserCertificate')
    },
    /**
     *  基本情報の入力なしでチャットを始める
     */
    gotoUserNoCertificate() {
      this.$emit('showUserNoCertificate')
    }
  }
}
</script>

<style scoped>
.fc-chat-user-certificate-result-dialog {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
}

.modal-header {
  margin-top: 0;
  text-align: center;
}

.modal-body {
  margin: 20px 0;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.user-certificate-button,
.user-no-certificate-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatJoin/dialog/FcChatUserCertificateResultDialog.vue